import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
import bookingService from "../services/booking.service";

const typMap: any = {
  pending: 1,
  confirmed: 3,
  return: 7,
  cancelled: 4,
};

export const getOwnerRentalList = createAsyncThunk(
  "personalRental/fetch",
  async (
    {
      requestType,
      type,
      qBooking,
      callBack = null,
    }: { requestType: number; type: number; qBooking: number; callBack?: any },
    { dispatch, getState }
  ) => {
    try {
      const reducer: any = getState();
      if (reducer.rentalsReducer.loadingList) return;

      if (
        !reducer.rentalsReducer.list.length ||
        type !== reducer.rentalsReducer.bookingType
      ) {
        dispatch(setLoadingList(true));
      }

      dispatch(setBookingType(type || 1));
      const resp: any = await bookingService.fetch({
        body: {
          page_no: reducer.rentalsReducer.page,
          filter: type || 1,
          request_type: requestType,
        },
      });
      // postAPICall(nextAPIRoutes.LIST_BOOKING, {
      //   page_no: reducer.rentalsReducer.page,
      //   filter: reducer.rentalsReducer.bookingType,
      //   request_type: requestType,
      // })
      callBack && callBack(resp.data.data?.list?.[0]);
      dispatch(setLoadingList(false));
      return { ...resp.data.data, qBooking } ?? [];
    } catch (e: any) {
      console.log(e);
      dispatch(setLoadingList(false));

      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const rentalSlice = createSlice({
  name: "rental",
  initialState: {
    bookingType: 1,
    page: 1,
    loadingList: false,
    list: [] as any,
    listMeta: {},
    selectedBookingId: 0,
    selectedBookingData: null as null | object,
  },
  reducers: {
    setBookingType: (state, { payload }: { payload: number }) => {
      state.bookingType = payload;
      // state.selectedBookingData = null;
      // state.selectedBookingId = 0;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setLoadingList: (state, { payload }) => {
      state.loadingList = payload;
    },
    setSelectedBookingId: (state, { payload }) => {
      state.selectedBookingId = payload;
      state.selectedBookingData =
        state.list.filter((l: any) => l.id === payload)?.[0] ?? null;
    },
    updateSelectedBookingData: (state, { payload }: { payload: any }) => {
      state.selectedBookingData = {
        ...state.selectedBookingData,
        ...payload.data,
      };
      state.list = state.list.map((l: any) =>
        l.id === payload.id ? { ...l, ...payload.data } : l
      );
    },
    clearBookings: (state) => {
      state.list = [];
      state.listMeta = [];
      state.loadingList = true;
    },
  },

  extraReducers: (builder) =>
    builder.addCase(getOwnerRentalList.fulfilled, (state, { payload }) => {
      state.list = payload?.list ?? [];
      state.listMeta = payload?.meta ?? [];

      if (payload?.qBooking) {
        state.selectedBookingId = payload?.qBooking;
        state.selectedBookingData =
          state.list.filter((l: any) => l.id === payload?.qBooking)?.[0] ??
          null;
      }
    }),
});

export default rentalSlice.reducer;
export const {
  setBookingType,
  setLoadingList,
  setPage,
  setSelectedBookingId,
  updateSelectedBookingData,
  clearBookings,
} = rentalSlice.actions;
